import React, { useEffect, useRef, useState } from 'react';
import ContainerLayout from '../../../../components/container-layout/ContainerLayout';
import { Box, Typography } from '@mui/material';
import NavigateListCustom from '../../../../components/navigation/NavigationListCustom';
import { routeName } from '../../../../routes/routeName';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { TFunction, useTranslation } from 'react-i18next';
import { ELibraryCategory, FILE_TYPE_DATA, LIBRARY_HEAD_STATUS, LIBRARY_HISTORY_STATUS, LIBRARY_LIKE } from '../../enum/elibrary_enum';
import { decodeId } from '../../../../utils/app.utils';
import { ELibraryFrontApi } from '../../../../api/e-library/e_library_front.api';
import { useDispatch, useSelector } from 'react-redux';
import { setLoading, unsetLoading } from '../../../../store/loading/loading.slice';
import { RootState } from '../../../../store/store';
import BoxBookDetail from './element/BoxBookDetail';
import { alertActive, alertError, alertSuccess } from '../../../../components/alert/swal';
import moment from 'moment';
import BooksCart from '../element/BooksCart';
import { globalLikeBookmark } from '../element/global_like_func';
import ModalCustom from '../../../../components/modal/modalCustomCms';
import IframePdf from '../../../../components/pdf-viewer/IframePdf';
import PdfViewer from '../../../../components/pdf-viewer/pdf_viewer';
import { status_data, status_data_audio_book, status_data_ebook, status_data_journal, status_data_podcast, status_data_thesis, status_data_video } from './BooksList';
import { saveAs } from 'file-saver';
import AudioPlaylistPlayer from '../podcast/element/AudioPlaylistPlayer';
import i18n from '../../../../i18n';

type Props = {
    library_category?: string;
    library_head_name?: string;
    library_head_pathname?: string;
    library_head_list_path?: string;
};



type Mode = 'NEW' | 'POPULAR' | 'ALL';
type detail_data = {
    id_library_head: number;
    library_head_name: string;
    library_category_desc: string;
    img_url: string;
    created_date: string;
    library_head_types: { name: string }[];
    library_author_by: string;
    remaining_stock: string;
    remaining_stock_rent: string;
    library_rent_day: number;
    library_rent_hour: number;
    language: string;
    remaining_stock_rent_out: boolean;
    price_amount: number;
    rent_count: number;
    sold_count: number;
    waiting_line: string;
    library_page: number;
    like_count: number;
    is_like?: boolean;
    count_download: number;
    ref_data: {
        author: string;
        img_url: string;
        id_library_head: number;
        title: string;
        library_head_status: string;
        is_like?: boolean;
        is_bookmark?: boolean;
    }[];
};

type previewBox = {
    content: React.ReactNode, is_two_column?: boolean, other_content?: React.ReactNode
}
const PreviewBox: React.FC<previewBox> = ({ content, is_two_column, other_content }) => {
    return <>
        {is_two_column ? (
            <Box className="grid grid-cols-12 gap-10">
                <Box className="col-span-12 xl:col-span-8">{content}</Box>
                <Box className="col-span-12 xl:col-span-4">{other_content}</Box>
            </Box>
        ) : (
            <>
                {content}
            </>
        )}
    </>
}

const BooksDetail: React.FC<Props> = ({ library_category, library_head_name = i18n.t("หนังสือ") as string, library_head_pathname = routeName.e_library.books, library_head_list_path = routeName.e_library.books_list }: Props) => {
    const is_ebook = (library_category === ELibraryCategory.E_BOOK);
    const is_journal = (library_category === ELibraryCategory.MAGAZINE);
    const is_thesis = (library_category === ELibraryCategory.THESIS);
    const is_podcast = (library_category === ELibraryCategory.PODCAST);
    const is_audio_book = (library_category === ELibraryCategory.AUDIO_BOOK);
    const is_video = (library_category === ELibraryCategory.VIDEO);
    const is_status_hidden = [ELibraryCategory.MAGAZINE, ELibraryCategory.THESIS, ELibraryCategory.VIDEO, ELibraryCategory.PODCAST].includes(library_category as ELibraryCategory);
    const allow_total_download = [ELibraryCategory.MAGAZINE, ELibraryCategory.THESIS].includes(library_category as ELibraryCategory);
    const allow_file_detail = [ELibraryCategory.MAGAZINE, ELibraryCategory.THESIS].includes(library_category as ELibraryCategory);
    const allow_two_column = [ELibraryCategory.PODCAST, ELibraryCategory.AUDIO_BOOK].includes(library_category as ELibraryCategory);

    const { t } = useTranslation();
    const [searchParams] = useSearchParams();
    const statusParams = is_ebook ?
        status_data_ebook(t) : is_journal ?
            status_data_journal(t) :
            is_thesis ? status_data_thesis(t) :
                is_podcast ? status_data_podcast(t) :
                    is_audio_book ? status_data_audio_book(t) :
                        is_video ? status_data_video(t) :
                            status_data(t);
    const location = useLocation();
    const pathname = location.pathname;
    const { id } = useParams();
    const Id = decodeId(id ?? '');
    const dispatch = useDispatch();
    const base_api = useSelector((state: RootState) => state.api.image_api);
    const navigate = useNavigate();

    const category = searchParams.get('status') as Mode | null;
    const category_title_name = statusParams?.find((x) => x.value === category)?.label || '';

    const [detail, set_detail] = useState<detail_data | null>(null);
    const [is_borrow_requested, set_is_borrow_requested] = useState<string>('');
    const [path_example_file, set_path_example_file] = useState<string>('');
    const [complete_file, set_complete_file] = useState<any>(null);
    const [show_modal_pdf, set_show_modal_pdf] = useState<boolean>(false);
    const [journal_file, set_journal_file] = useState<any>(null);
    const [thesis_file, set_thesis_file] = useState<any>(null);
    const [video_file, set_video_file] = useState<any>(null);
    const [podcast_file, set_podcast_file] = useState<any[]>([]);
    const [audio_book_file, set_audio_book_file] = useState<any[]>([]);



    const [cartCount, setCartCount] = useState(0);
    const cartRef = useRef<HTMLButtonElement | null>(null);

    const handleOpenModalPdf = (url: string,) => {
        set_show_modal_pdf(true);
    }
    const handleCloseModalPdf = () => {
        set_show_modal_pdf(false);
    }

    const fetchPdfAsBlob = async (id_library_file: number) => {
        try {
            const blob = await ELibraryFrontApi.downloadFile(id_library_file).then((res) => new Blob([res.data], { type: "application/pdf" }))
            return URL.createObjectURL(blob);
        } catch (err) {
            console.log(err, 'r')
        }
    };
    const handleDownloadFile = async (id_library_file: number, file_name: string) => {
        dispatch(setLoading());
        await ELibraryFrontApi.downloadFile(id_library_file).then((res) => {
            if (res.status < 300) {
                const response = res.data;
                const blob_file = new Blob([response, { type: "application/pdf" }]);
                saveAs(blob_file, file_name);
                if (Id) {
                    handleGetDetail(Id);
                }
            }
        }).catch((err) => {
            console.log(err)
        }).finally(() => {
            dispatch(unsetLoading());
        })
    }
    const handleAddToCart = async (id_library_head: number) => {
        dispatch(setLoading());
        await ELibraryFrontApi.addToCart([{ id_library_head, qty: 1 }])
            .then((res) => {
                if (res.status < 300) {
                    alertSuccess(
                        t("สั่งซื้อ"),
                        is_ebook ? t('เพิ่มรายการ E-book ลงในรถเข็นเรียบร้อยแล้ว') : t('เพิ่มรายการหนังสือลงในรถเข็นเรียบร้อยแล้ว'),
                        t('ชำระเงิน'), () => {
                            navigate(routeName.e_library.books_shop_cart);
                        });
                    setCartCount((prev) => prev + 1);
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    };

    const handleGetDetail = async (id_library_head: number) => {
        dispatch(setLoading());
        await ELibraryFrontApi.findOne(id_library_head)
            .then(async (res) => {
                if (res.status < 300) {
                    const response = res.data?.data;
                    const library_files: any[] = response?.library_files || [];
                    const find_one_cover_file = library_files?.find((x) => x?.library_file_document === FILE_TYPE_DATA.COVER_FILE);
                    const find_one_example_file = library_files?.find((x) => x?.library_file_document === FILE_TYPE_DATA.EXAMPLE_BOOK);
                    const find_one_journal_file = library_files?.find((x) => x?.library_file_document === FILE_TYPE_DATA.JOURNAL_FILE);
                    const complete_file_data = library_files?.find((x) => x?.library_file_document === FILE_TYPE_DATA.COMPLETE_BOOK);
                    const complete_file_thesis = library_files?.find((x) => x?.library_file_document === FILE_TYPE_DATA.COMPLETE_THE_SIS_FILE);
                    const podcast_file_data = library_files?.filter((x) => x?.library_file_document === FILE_TYPE_DATA.POD_CAST);
                    const audio_book_file_data = library_files?.filter((x) => x?.library_file_document === FILE_TYPE_DATA.AUDIO_BOOK);
                    const video_file_data = library_files?.find((x) => x?.library_file_document === FILE_TYPE_DATA.VIDEO_FILE);
                    const cover_img_url_path: string = `${base_api}/${find_one_cover_file?.file_path}${find_one_cover_file?.file_name}`;
                    const library_head_types: any[] = response?.library_head_types || [];
                    const ref_data: any[] = response?.ref_data?.items || [];
                    if (find_one_journal_file) {
                        set_journal_file(find_one_journal_file);
                    }
                    if (complete_file_thesis) {
                        set_thesis_file(complete_file_thesis);
                    }
                    if (video_file_data) {
                        set_video_file(video_file_data);
                    }
                    if (podcast_file_data?.length > 0) {
                        set_podcast_file(podcast_file_data)
                    }
                    if (audio_book_file_data?.length > 0) {
                        set_audio_book_file(audio_book_file_data)
                    }
                    // อัปเดตสถานะ/รายละเอียดก่อน เพื่อให้ปุ่มและสถานะ (เช่น ตอนคืน E-book) รีเฟรชทันที
                    // ไม่ต้องรอ await การดาวน์โหลดไฟล์ PDF (ซึ่ง ebook/วารสาร/วิทยานิพนธ์จะโหลดเป็น blob)
                    if (complete_file_data) {
                        set_complete_file(complete_file_data);
                    }
                    set_is_borrow_requested(response?.is_borrow_requested as LIBRARY_HISTORY_STATUS);
                    set_detail({
                        ...response,
                        img_url: cover_img_url_path,
                        ref_data: ref_data?.map((list) => {
                            const img_url = `${base_api}/${list?.file_path}${list?.file_name}`;
                            return {
                                author: list?.library_author_by || '',
                                title: list?.library_head_name || '',
                                is_bookmark: list?.is_bookmark,
                                is_like: list?.is_like,
                                library_head_status: list?.library_head_status,
                                id_library_head: list?.id_library_head,
                                img_url: img_url,
                            };
                        }),
                        library_head_types: library_head_types?.map((list) => {
                            return {
                                name: list?.library_type_name,
                            };
                        }),
                    });
                    // โหลดไฟล์ PDF (blob) หลังอัปเดต state แล้ว
                    if (find_one_example_file || find_one_journal_file || complete_file_thesis) {
                        if (allow_file_detail || is_ebook) {
                            // กำลังยืม จะได้ file สมบูรณ์
                            if (response?.is_borrow_requested === LIBRARY_HISTORY_STATUS.BORROW) {
                                const path_file = await fetchPdfAsBlob(complete_file_data?.id_library_file);
                                set_path_example_file(path_file ?? "")
                            } else {
                                const path_file = await fetchPdfAsBlob(complete_file_thesis?.id_library_file || find_one_journal_file?.id_library_file || find_one_example_file?.id_library_file);
                                set_path_example_file(path_file ?? "")
                            }
                        } else {
                            set_path_example_file(`${base_api}/${find_one_example_file?.file_path}${find_one_example_file?.file_name}`);
                        }
                    } else {
                        set_path_example_file('');
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    };

    // console.log(thesis_file,'sd')

    const handleRentBook = async (id_library_head: number, library_head_name: string, day: number, hour: number) => {
        alertActive(
            is_ebook ? t('ยืม E-book') : is_audio_book ? t("ยืมหนังสือเสียง") : t('ยืมหนังสือ'),
            undefined,
            undefined,
            undefined,
            async () => {
                dispatch(setLoading());
                await ELibraryFrontApi.borrowBook(id_library_head)
                    .then((res) => {
                        if (res.status < 300) {
                            alertSuccess(is_ebook ? t('ยืม E-book') : is_audio_book ? t("ยืมหนังสือเสียง") : t('ยืมหนังสือ'), is_ebook ? t('ยืม E-book เรียบร้อย') : is_audio_book ? t("ยืมหนังสือเสียง เรียบร้อย") : t('ยืมหนังสือ เรียบร้อย'));
                            handleGetDetail(id_library_head);
                        }
                    })
                    .catch((err) => {
                        alertError(is_audio_book ? t("ยืมหนังสือเสียง") : t('ยืมหนังสือ'), err?.response?.data?.message || t('ไม่สำเร็จ ลองใหม่อีกครั้ง'));
                        console.log(err);
                    })
                    .finally(() => {
                        dispatch(unsetLoading());
                    });
            },
            undefined,
            undefined,
            `
    ${is_ebook ? `E-book : ${library_head_name || '-'}` : t("หนังสือ : {{name}}", { name: library_head_name || '-' })}<br/>
    ${t("กำหนดคืน {{date}} น.", { date: moment().add(i18n.language === "en" ? 0 : 543, 'year').add('day', day).add('hour', hour).format('DD/MM/YYYY HH:mm') })}`
        );
    };

    const handleReserveBook = async (id_library_head: number, library_head_name: string, remaining_next_due_time: string) => {
        alertActive(
            is_ebook ? t('จอง E-book') : is_audio_book ? t("จองหนังสือเสียง") : t('จองหนังสือ'),
            undefined,
            undefined,
            undefined,
            async () => {
                dispatch(setLoading());
                await ELibraryFrontApi.bookedBook(id_library_head)
                    .then((res) => {
                        if (res.status < 300) {
                            alertSuccess(
                                is_ebook ? t('จอง E-book') : is_audio_book ? t("จองหนังสือเสียง") : t('จองหนังสือ'),
                                is_ebook ? t('จอง E-book เรียบร้อย') : is_audio_book ? t('จองหนังสือเสียง เรียบร้อย') : t('จองหนังสือ เรียบร้อย')
                            );
                            handleGetDetail(id_library_head);
                        }
                    })
                    .catch((err) => {
                        alertError(
                            is_ebook ? t('จอง E-book') : is_audio_book ? t('จอง หนังสือเสียง') : t('จองหนังสือ'), err?.response?.data?.message || t('ไม่สำเร็จ ลองใหม่อีกครั้ง'));
                        console.log(err);
                    })
                    .finally(() => {
                        dispatch(unsetLoading());
                    });
            },
            undefined,
            undefined,
            `${is_ebook ? t('ต้องการจอง E-book หรือไม่?') : is_audio_book ? t('ต้องการจองหนังสือเสียง หรือไม่?') : t('ต้องการจองหนังสือ หรือไม่?')}<br/>
    ${is_ebook ? `E-book : ${library_head_name || '-'}` : t("หนังสือ : {{name}}", { name: library_head_name || '-' })}<br/>
        ${remaining_next_due_time ? t("รอคิวประมาณ") : ""} ${remaining_next_due_time || ''}`
        );
    };

    const handleCheckRentBook = async (
        id_library_head: number,
        library_head_name: string,
        library_rent_day: number,
        library_rent_hour: number,
        _callback?: () => void
    ) => {
        dispatch(setLoading());
        await ELibraryFrontApi.getWaitingLineBooked(id_library_head)
            .then((res) => {
                if (res.status < 300) {
                    const remaining_next_due_time = res.data?.data?.remaining_next_due_time;
                    if (remaining_next_due_time) {
                        handleReserveBook(id_library_head, library_head_name, remaining_next_due_time);
                    } else {
                        handleRentBook(id_library_head, library_head_name, library_rent_day, library_rent_hour);
                    }
                }
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                dispatch(unsetLoading());
            });
    };

    const handleCancelRent = (id_library_head: number) => {
        alertActive(
            is_ebook ? t('ยกเลิกการยืม E-book') : t('ยกเลิกการยืมหนังสือ'),
            is_ebook ? t('ต้องการยกเลิกการยืม E-book?') : t('ต้องการยกเลิกการยืมหนังสือ?'),
            undefined,
            undefined,
            async () => {
                dispatch(setLoading());
                await ELibraryFrontApi.cancelBorrow(id_library_head)
                    .then((res) => {
                        if (res.status < 300) {
                            alertSuccess(is_ebook ? t('ยกเลิกการยืม E-book') : t('ยกเลิกการยืมหนังสือ'), is_ebook ? t('ยกเลิกการยืม E-book เรียบร้อยแล้ว') : t('ยกเลิกการยืมหนังสือ เรียบร้อยแล้ว'));
                            handleGetDetail(id_library_head);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    })
                    .finally(() => {
                        dispatch(unsetLoading());
                    });
            }
        );
    };
    const handleReturnBorrow = (id_library_head: number) => {
        alertActive(
            is_ebook ? t('คืน E-book') : t('คืนหนังสือ'),
            is_ebook ? t('ต้องการคืน E-book?') : t('ต้องการคืนหนังสือ?'),
            undefined,
            undefined,
            async () => {
                dispatch(setLoading());
                await ELibraryFrontApi.returnBorrow(id_library_head)
                    .then((res) => {
                        if (res.status < 300) {
                            alertSuccess(is_ebook ? t('คืน E-book') : t('คืนหนังสือ'), is_ebook ? t('คืน E-book เรียบร้อยรอการยืนยันการคืน') : t('คืนหนังสือ เรียบร้อยแล้วรอการยืนยันการคืน'));
                            handleGetDetail(id_library_head);
                        }
                    })
                    .catch((err) => {
                        alertError(is_ebook ? t('คืน E-book') : t('คืนหนังสือ'), err?.response?.data?.message || t('ไม่สำเร็จ ลองใหม่อีกครั้ง'));
                        console.log(err);
                    })
                    .finally(() => {
                        dispatch(unsetLoading());
                    });
            }
        );
    };

    useEffect(() => {
        if (Id) {
            handleGetDetail(Id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Id]);


    console.log(is_audio_book,'is_audio_book')

    return (
        <ContainerLayout
            title={is_ebook ? `E-book : ${detail?.library_head_name || ''}` : `${library_head_name} : ${detail?.library_head_name || ''}`}
            sub_title_custom={<Box my={2}></Box>}
            hidden_sub_title
            navigateContent={
                <NavigateListCustom
                    navigateData={[
                        { key: t('จัดการข้อมูล E-Library'), name: t('จัดการข้อมูล E-Library'), pathName: library_head_pathname, onClick: () => { }, disabled_match: true },
                        {
                            key: 'A',
                            name: is_ebook ? "E-book" : library_head_name,
                            pathName: is_ebook ? routeName.e_library.e_books : library_head_pathname
                        },
                        {
                            key: 'B', name: category_title_name ?? '',
                            pathName: is_ebook ? routeName.e_library.e_books_list : library_head_list_path,
                            searchParams: { status: category || undefined }
                        },
                        {
                            key: 'C',
                            name: is_ebook ? `E-book : ${detail?.library_head_name || ''}` : `${library_head_name} : ${detail?.library_head_name || ''}`,
                            pathName: pathname
                        },
                    ]}
                />
            }
            buttonContent={<BooksCart ref={cartRef} cartCount={cartCount} />}
            content={
                <>
                    <PreviewBox
                        is_two_column={allow_two_column}
                        other_content={
                            <Box>
                                {(podcast_file?.length > 0 && is_podcast) && (
                                    <AudioPlaylistPlayer
                                        fullWidth
                                        items={podcast_file?.length > 0 ? podcast_file?.map((list) => {
                                            const url_audio = `${base_api}/${list?.file_path}${list?.file_name}`;
                                            return {
                                                title: list?.file_name || "-",
                                                url: url_audio,
                                                disabled_item: false,
                                                date: list?.created_date || "-",
                                                is_example: list?.is_example
                                            }
                                        }) : []}
                                    />
                                )}
                                {(audio_book_file?.length > 0 && is_audio_book) && (
                                    <AudioPlaylistPlayer
                                        fullWidth
                                        items={audio_book_file?.length > 0 ? audio_book_file?.map((list) => {
                                            const url_audio = `${base_api}/${list?.file_path}${list?.file_name}`;
                                            return {
                                                title: list?.file_name || "-",
                                                url: url_audio,
                                                disabled_item: is_borrow_requested === LIBRARY_HISTORY_STATUS.BORROW ? false : !list?.is_example,
                                                date: list?.created_date || "-",
                                                is_example: list?.is_example
                                            }
                                        }) : []}
                                    />
                                )}
                            </Box>
                        }
                        content={
                            <Box>
                                {detail && (
                                    <BoxBookDetail
                                        show_column={is_podcast || is_video}
                                        full_width={allow_two_column}
                                        img_url={(is_video && video_file) ? (video_file?.link_file ? video_file?.link_file : `${base_api}/${video_file?.file_path}${video_file?.file_name}`) : detail?.img_url || ''}
                                        ref_data={detail?.ref_data || []}
                                        callback={async () => {
                                            handleGetDetail(detail?.id_library_head);
                                        }}
                                        is_video_url={is_video}
                                        path_view_all={
                                            is_journal ? routeName.e_library.journal_list :
                                                is_ebook ? routeName.e_library.e_books_list :
                                                    is_audio_book ? routeName.e_library.audio_book_list :
                                                        is_podcast ? routeName.e_library.podcast_list :
                                                            is_video ? routeName.e_library.video_list :
                                                                is_thesis ? routeName.e_library.the_sis_list :
                                                                    undefined}
                                        path_other_content={
                                            is_journal ? routeName.e_library.journal_detail :
                                                is_ebook ? routeName.e_library.e_books_detail :
                                                    is_audio_book ? routeName.e_library.audio_book_detail :
                                                        is_video ? routeName.e_library.video_detail :
                                                            is_podcast ? routeName.e_library.podcast_detail :
                                                                is_thesis ? routeName.e_library.the_sis_detail :
                                                                    undefined
                                        }
                                        total_download={allow_total_download ? String(detail?.count_download || "0") : undefined}
                                        hidden_borrow={is_status_hidden || is_video || is_podcast}
                                        hidden_sales={is_status_hidden || is_podcast || is_video || is_audio_book}
                                        is_ebook_or_other={(allow_file_detail && complete_file) ? {
                                            file_size: complete_file?.file_size,
                                            file_type: "PDF"
                                        } : (allow_file_detail && journal_file) ? {
                                            file_size: journal_file?.file_size,
                                            file_type: "PDF",
                                            total_page: String(detail?.library_page || "")
                                        } : (allow_file_detail && thesis_file) ? {
                                            file_size: thesis_file?.file_size,
                                            file_type: "PDF",
                                            total_page: String(detail?.library_page || "")
                                        } : undefined}
                                        language_content={is_video ? (
                                            <Box my={1}>
                                                <Typography>{t("ภาษา :")} {detail?.language || "-"}</Typography>
                                            </Box>
                                        ) : undefined}
                                        hidden_sales_count={is_audio_book}
                                        data={{
                                            checkedLike: detail?.is_like,
                                            setCheckedLike: async () => {
                                                await globalLikeBookmark(detail?.id_library_head, LIBRARY_LIKE.LIKE);
                                                handleGetDetail(detail?.id_library_head);
                                            },
                                            author: detail?.library_author_by,
                                            title: detail?.library_head_name,
                                            date: detail?.created_date,
                                            library_author_by: detail?.library_author_by || '',
                                            library_head_types: detail?.library_head_types || [],
                                            library_category_desc: detail?.library_category_desc || '',
                                            remaining_stock: detail?.remaining_stock,
                                            remaining_stock_rent: detail?.remaining_stock_rent,
                                            remaining_stock_rent_out: detail?.remaining_stock_rent_out,
                                            rent_count: detail?.rent_count,
                                            waiting_line: detail?.waiting_line,
                                            sold_count: detail?.sold_count,
                                            library_page: detail?.library_page,
                                            price_amount: detail?.price_amount,
                                            like_count: detail?.like_count,
                                            button_read: {
                                                enable: (!(is_status_hidden || is_audio_book) && [
                                                    LIBRARY_HISTORY_STATUS.WAITING_APPROVE_BORROW,
                                                    LIBRARY_HISTORY_STATUS.WAITING_APPROVE_RETURN,
                                                    LIBRARY_HISTORY_STATUS.BORROW,
                                                    LIBRARY_HISTORY_STATUS.APPROVE_RETURN
                                                ].includes(is_borrow_requested as LIBRARY_HISTORY_STATUS)) && !is_podcast,
                                                text: (LIBRARY_HISTORY_STATUS.BORROW === is_borrow_requested && is_ebook) ? t('อ่าน') : t('ตัวอย่าง'),
                                                onClick: () => handleOpenModalPdf(path_example_file),
                                                disabled: !path_example_file,
                                            },
                                            button_return: {
                                                enable: !is_status_hidden && [LIBRARY_HISTORY_STATUS.WAITING_APPROVE_BORROW, LIBRARY_HISTORY_STATUS.BORROW].includes(is_borrow_requested as LIBRARY_HISTORY_STATUS),
                                                onClick: () => is_borrow_requested === LIBRARY_HISTORY_STATUS.BORROW ? handleReturnBorrow(detail?.id_library_head) : handleCancelRent(detail?.id_library_head),
                                                text: (is_borrow_requested === LIBRARY_HISTORY_STATUS.WAITING_APPROVE_BORROW) ?
                                                    (is_ebook ? t('ยกเลิกการยืม E-book') : t('ยกเลิกการยืมหนังสือ')) :
                                                    (is_ebook ? t('คืน E-book') : t('คืนหนังสือ')),
                                            },
                                            button_example: {
                                                enable: (!is_status_hidden && is_borrow_requested == '') && !(is_podcast || is_audio_book),
                                                text: t('ตัวอย่าง'),
                                                onClick: () => handleOpenModalPdf(path_example_file),
                                                disabled: !path_example_file,
                                            },
                                            button_rent: {
                                                enable: !(is_status_hidden || is_audio_book) && !detail?.remaining_stock_rent_out && (is_borrow_requested == LIBRARY_HISTORY_STATUS.WAITING_APPROVE_BORROW ? false :
                                                    ((is_borrow_requested == '' || [LIBRARY_HISTORY_STATUS.WAITING_APPROVE_BORROW, LIBRARY_HISTORY_STATUS.APPROVE_RETURN].includes(is_borrow_requested as LIBRARY_HISTORY_STATUS)))),
                                                text: t('ยืม'),
                                                onClick: () => {
                                                    detail?.id_library_head &&
                                                        handleCheckRentBook(detail?.id_library_head, detail?.library_head_name, detail?.library_rent_day, detail?.library_rent_hour);
                                                },
                                            },
                                            button_buy: {
                                                enable: (!is_status_hidden && (is_borrow_requested == '') ||
                                                    [LIBRARY_HISTORY_STATUS.WAITING_APPROVE_BORROW,
                                                    LIBRARY_HISTORY_STATUS.BORROW,
                                                    LIBRARY_HISTORY_STATUS.WAITING_APPROVE_RETURN,
                                                    LIBRARY_HISTORY_STATUS.APPROVE_RETURN].includes(is_borrow_requested as LIBRARY_HISTORY_STATUS)) && !(is_podcast || is_audio_book),
                                                text: t('สั่งซื้อ'),
                                                onClick: (e) => {
                                                    handleAddToCart(detail?.id_library_head);
                                                },
                                            },
                                            button_view: {
                                                enable: allow_file_detail,
                                                text: t("อ่าน"),
                                                onClick: () => handleOpenModalPdf(path_example_file)
                                            },
                                            button_rent_success: {
                                                enable: (is_borrow_requested == '' || is_borrow_requested == LIBRARY_HISTORY_STATUS.APPROVE_RETURN) && is_audio_book && !detail?.remaining_stock_rent_out,
                                                text: t("ยืม"),//PODCAST
                                                onClick: () => detail?.id_library_head &&
                                                    handleCheckRentBook(detail?.id_library_head, detail?.library_head_name, detail?.library_rent_day, detail?.library_rent_hour)
                                            },
                                            button_booked: {
                                                enable: (is_borrow_requested == '' || is_borrow_requested == LIBRARY_HISTORY_STATUS.APPROVE_RETURN) && !is_status_hidden && detail?.remaining_stock_rent_out,
                                                text: t("จอง"),
                                                onClick: () => detail?.id_library_head && handleCheckRentBook(detail?.id_library_head, detail?.library_head_name || "", detail?.library_rent_day, detail?.library_rent_hour)
                                            },
                                            ...(journal_file && {
                                                button_download: {
                                                    enable: allow_file_detail,
                                                    text: t("ดาวน์โหลด"),
                                                    disabled: !journal_file,
                                                    onClick: () => journal_file && handleDownloadFile(journal_file?.id_library_file, journal_file?.file_name)
                                                },
                                            }),
                                            ...(thesis_file && {
                                                button_download: {
                                                    enable: allow_file_detail,
                                                    text: t("ดาวน์โหลด"),
                                                    disabled: !thesis_file,
                                                    onClick: () => thesis_file && handleDownloadFile(thesis_file?.id_library_file, thesis_file?.file_name)
                                                },
                                            })
                                        }}
                                    />
                                )}
                            </Box>
                        }
                    />


                    {show_modal_pdf && (
                        <ModalCustom
                            handleClose={handleCloseModalPdf}
                            onClick={() => { }}
                            open
                            title={detail?.library_head_name || "_"}
                            subTitle={t("โดย : {{name}}", { name: detail?.library_author_by || "-" })}
                            scrollBody
                            hintSubmitButton
                            cancelButtonName={t("ปิด")}
                            enable_up_transition
                            maxWidth='xl'
                            form={
                                <Box className="w-full">
                                    {(is_ebook || allow_file_detail) ? (
                                        <PdfViewer fileUrl={path_example_file} />
                                    ) : (
                                        <IframePdf url={path_example_file} />
                                    )}
                                </Box>
                            }
                        />
                    )}
                </>
            }
        />
    );
};

export default BooksDetail;
